<template>
    <div
        class="case"
        :class="{
      showActions: index == caseShowActions,
      selected: beSelected.indexOf(item.o_id) !== -1
    }"
        @mouseenter="showOption($event)"
        @click="enterOrSelect(item)"
        @mouseleave="hideOption($event)"
    >
        <collapse>
            <file-closet
                v-if="index == caseShowActions"
                :actions="fileActions"
                @actionSelect="actionDeal"
            ></file-closet>
        </collapse>
        <div class="option icon" @click.stop="showOptions(index)">&#xe98a;</div>
        <div class="case-name">
            <span class="icon">&#xe92d;</span>
            <span :title="item.caseName">{{ item.caseName }}</span>
        </div>
        <div class="case-body">
            <div class="case-mask" v-if="editMode">
                <div class="checkbox"></div>
            </div>
            <div class="doc-num" v-if="item.doc !== 0">
                <span class="icon doc">&#xe9ac;</span>
                <span>
                    {{
                    `${item.doc} ${$t("content.document")}${
                    item.doc !== 1 && inEnglish ? "s" : ""
                    }`
                    }}
                </span>
            </div>
            <div class="graph-num" v-if="item.graph !== 0">
                <span class="icon graph">&#xe908;</span>
                <span>
                    {{
                    `${item.graph} ${$t("content.graph")}${
                    item.graph !== 1 && inEnglish ? "s" : ""
                    }`
                    }}
                </span>
            </div>
            <div
                class="graph-num"
                v-if="item.graph == 0 && item.doc == 0"
            >0 {{ $t("content.item") }}</div>
        </div>
        <div class="last-saved">{{ `${$t("content.last-save")} : ${item.lastSaved}` }}</div>
    </div>
</template>

<script>
import fileCloset from "@/components/fileCloset";
import collapse from "@/components/transition";
import { mapState, mapMutations, mapActions } from "vuex";
export default {
    components: {
        fileCloset,
        collapse
    },
    props: {
        item: {
            type: Object,
            default() {
                return {};
            }
        },
        index: {
            type: Number,
            default: 0
        },
        caseShowActions: {
            type: Number,
            default: -1
        }
    },
    computed: {
        ...mapState(["beSelected", "editMode", "allCases", "requestPending"]),
        //index of the case in all cases
        indexInAllCase() {
            for (let i in this.allCases) {
                if (this.allCases[i]["o_id"] == this.item["o_id"]) {
                    return i;
                }
            }
        },
        //whether the language is english
        inEnglish() {
            return this.$i18n.locale == "en";
        }
    },
    data() {
        return {
            fileActions: [
                { icon: "\ue90c", action: "action.rename" },
                { icon: "\ue926", action: "action.delete" }
            ]
        };
    },
    methods: {
        ...mapMutations(["select", "enterCase", "caseRename"]),
        ...mapActions(["delete", "update"]),

        showOption(e) {
            let target = e.target;
            let classList = target.classList;
            if (!classList.contains("active") && !this.editMode) {
                classList.add("active");
            }
        },
        hideOption(e) {
            let target = e.target;
            let classList = target.classList;
            if (classList.contains("active") && !this.editMode) {
                classList.remove("active");
            }
        },
        showOptions(index) {
            this.$emit("showActions", "case", index);
        },
        enterOrSelect(item) {
            if (this.editMode) {
                this.select(item.o_id);
            } else {
                this.$router.push({
                    path: `/${this.$curPath()[0]}/${this.item.caseName}`
                });
            }
        },
        /**
         * select an action
         * @param {Number} index -index of the action
         */
        actionDeal(index) {
            this.$emit("hideActions");
            switch (index) {
                case 0:
                    this.renameCase();
                    return;
                case 1:
                    this.deleteCase();
                    return;
            }
        },
        deleteCase() {
            if (this.requestPending) {
                this.$toast({ status: 3, forceFadeOut: true });
                return;
            }
            this.$dialog({
                type: "confirm",
                name: this.item.caseName,
                title: "dialog.action-confirm"
            });
            this.$fire.$on("confirm", confirm => {
                if (confirm) {
                    this.select(this.item["o_id"]);
                    this.delete()
                        .then(() => {
                            this.$toast();
                        })
                        .catch(() => {
                            this.$toast({
                                status: 1,
                                forceFadeOut: true
                            });
                        });
                    this.$toast({ status: 2 });
                }
                this.$fire.$off("confirm");
            });
        },
        renameCase() {
            if (this.requestPending) {
                this.$toast({ status: 3, forceFadeOut: true });
                return;
            }
            this.$dialog({ type: "dialog", title: "dialog.rename-case" });
            this.$fire.$on("caseName", (data, timestamp) => {
                if (data) {
                    let backupName = this.item["caseName"];

                    this.caseRename({ name: data, oid: this.item["o_id"] });
                    this.update({
                        action: "renameCase",
                        case_title: data,
                        vc_id: this.item["o_id"].slice(1)
                    })
                        .then(res => {
                            if (res.data.code == 200) {
                                this.$toast();
                            } else {
                                this.caseRename({
                                    name: backupName,
                                    oid: this.item["o_id"]
                                });
                                this.$toast({
                                    status: 1,
                                    forceFadeOut: true
                                });
                            }
                        })
                        .catch(res => {
                            this.caseRename({
                                name: backupName,
                                oid: this.item["o_id"]
                            });
                            this.$toast({
                                status: 1,
                                forceFadeOut: true
                            });
                        });
                    this.$toast({ status: 2 });
                }
                this.$fire.$off("caseName");
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.case {
    position: relative;
    padding: 10px;
    margin: 12px 10px;
    width: 230px;
    height: 100px;
    border: 2px solid transparent;
    background: $base-color;
    box-shadow: 2px 3px 10px -4px rgba(13, 36, 60, 1);
    border-radius: 0px 4px 4px 4px;
    transition: all 500ms;
    cursor: pointer;
    div.option {
        display: none;
    }
    &.active,
    &.showActions {
        box-shadow: 2px 3px 30px -10px rgba(13, 36, 60, 1);
        & > div.option {
            position: absolute;
            display: block;
            font-size: 26px;
            color: $light-purple;
            right: 8px;
            top: 8px;
            z-index: 100;
        }
    }
    .case-body {
        @include flex;
        height: 40px;
        justify-content: space-between;
        padding-right: 23px;
        .doc.icon {
            color: #156ec9;
        }
        .graph.icon {
            color: #fd9620;
        }
        & > .doc-num,
        & > .graph-num {
            font-size: 13px;
            color: $dark-purple;
        }
    }
    .last-saved {
        color: #b8bbc2;
        font-size: 12px;
        line-height: 16px;
    }
    .case-name {
        @include flex;
        justify-content: flex-start;
        height: 25px;
        padding-bottom: 5px;
        position: relative;
        .icon {
            margin-right: 6px;
            font-size: 20px;
            color: $dark-purple;
        }
        & > span:last-child {
            color: $dark-purple;
            font-size: 16px;
            overflow: hidden;
            white-space: nowrap;
            margin-right: 16px;
            text-overflow: ellipsis;
        }
        &::after {
            @include after;
            height: 1px;
            width: 190px;
            background-color: $border-color;
            bottom: -1px;
            left: 10px;
        }
    }
}
.case.selected {
    border-color: $light-purple;
    .checkbox {
        background-color: $light-purple;
        &::after {
            content: "\e99e";
            font-family: "gekko_fonts" !important;
            font-size: 18px;
            left: 6px;
            top: 6px;
            color: $base-color;
            position: absolute;
        }
    }
}
.case-mask {
    @include flex;
    position: absolute;
    left: -2px;
    bottom: -2px;
    width: 230px;
    height: 63px;
    background: rgba(21, 110, 201, 0.4);
    border-radius: 0px 0px 4px 4px;
    .checkbox {
        width: 30px;
        height: 30px;
        border: 1px solid $light-purple;
        border-radius: 4px;
        cursor: pointer;
        background-color: $base-color;
        transition: all 300ms;
        position: relative;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/caseCard.vue